import { render, staticRenderFns } from "./VerifyCodeComponent.vue?vue&type=template&id=722b5260&scoped=true"
import script from "./VerifyCodeComponent.vue?vue&type=script&lang=js"
export * from "./VerifyCodeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722b5260",
  null
  
)

export default component.exports